export default __webpack_public_path__ + "static/media/dr.thomas.8c79b65a.png";